// This is a generated file!
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _define = require("../../define");
const iconSkTemplate = document.createElement('template');
iconSkTemplate.innerHTML = '<svg class="icon-sk-svg" xmlns="http://www.w3.org/2000/svg" width=24 height=24 viewBox="0 0 24 24"><path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/></svg>';
(0, _define.define)('event-icon-sk', class extends HTMLElement {
    connectedCallback() {
        const icon = iconSkTemplate.content.cloneNode(true);
        while(this.firstChild){
            this.removeChild(this.firstChild);
        }
        this.appendChild(icon);
    }
});
